/**
 * Shown when this phone has no portal session — instead of the admin login
 * page, which a driver has no credentials for and must never be sent to.
 *
 * For a DRIVER (and an operator) the only way in is still a fresh enrolment
 * link from the office, so the screen says exactly that, with one tap to ask
 * for it on WhatsApp. Nothing about that changed.
 *
 * Underneath it, quietly, is the one door that is not a link: Pickup Hungary
 * office staff sign in with their own dashboard account. It sits last and in
 * English because it is for a handful of colleagues, not for the drivers this
 * screen is written for — but it has to be here, because this is where an
 * expired dispatch session lands.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { KeyIcon } from './Icons';
import BrandLogo from './BrandLogo';
import OfficeWhatsAppButton from './OfficeWhatsAppButton';

export const NEW_LINK_MESSAGE = 'Szia! Új belépési linket kérek a Pickup Hungary portálhoz.';

export const STAFF_LINK_TEXT = 'Pickup Hungary staff: sign in with your account';

export default function PortalGate({
  title = 'Kérj új belépési linket',
  body = 'Ez a telefon nincs összekötve a fiókoddal, vagy a hozzáférés lejárt. Írj az irodának WhatsAppon, és küldenek egy új linket — egy koppintás, és újra bent vagy.',
}) {
  return (
    <>
      <div className="pp-topbrand">
        <BrandLogo variant="white" height={48} />
      </div>

      <div className="pp-gate">
        <div className="pp-gate__mark">
          <KeyIcon size={30} />
        </div>
        <h1 className="pp-gate__title">{title}</h1>
        <p className="pp-gate__body">{body}</p>
        <p className="pp-gate__body">A link WhatsAppon vagy SMS-ben érkezik.</p>
        <OfficeWhatsAppButton message={NEW_LINK_MESSAGE} className="pp-gate__action" />
        <p className="pp-gate__body pp-gate__staff">
          <Link to="/portal/login">{STAFF_LINK_TEXT}</Link>
        </p>
      </div>
    </>
  );
}
